import axios from "axios";

export const axiosInstance = (token?: string): void => {
  axios.defaults.headers.common = { "Authorization": `Bearer ${token}` };
};
